import { combineReducers } from 'redux'
import standings from './standings'

const survivorApp = combineReducers({
  standings
})

export default survivorApp
